// +----------------------------------------------------------------------
// | Desc:全局路由定义
// +----------------------------------------------------------------------
const allRouters = [
  // +----------------------------------------------------------------------
  // | Desc:订单
  // +----------------------------------------------------------------------
  {
    path: "/projectlist100",
    name: "projectlist100",
    title: "装修排放",
    component: () => import("@/pages/project/projectlist100"),
    meta: {
      requireAuth: true,
    },
  },
     // +----------------------------------------------------------------------
  // | Desc:订单
  // +----------------------------------------------------------------------
  {
    path: "/projectlist200",
    name: "projectlist200",
    title: "排放工地",
    component: () => import("@/pages/project/projectlist200"),
    meta: {
      requireAuth: true,
    },
  },

  // +----------------------------------------------------------------------
  // | Desc:备案
  // +----------------------------------------------------------------------
  {
    path: "/filing",
    name: "filing",
    title: "备案管理",
    component: () => import("@/pages/filing/filing"),
    meta: {
      requireAuth: true,
    },
  },


  // +----------------------------------------------------------------------
  // | Desc:联单
  // +----------------------------------------------------------------------
  {
    path: "/electronicbillPFZL",
    name: "electronicbillPFZL",
    title: "排放总量",
    component: () => import("@/pages/electronicbill/electronicbillPFZL"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/electronicbillPFLD",
    name: "electronicbillPFLD",
    title: "排放联单",
    component: () => import("@/pages/electronicbill/electronicbillPFLD"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/electronicbillPFLX",
    name: "electronicbillPFLX",
    title: "排放类型",
    component: () => import("@/pages/electronicbill/electronicbillPFLX"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/electronicbillJRLD",
    name: "electronicbillJRLD",
    title: "今日联单",
    component: () => import("@/pages/electronicbill/electronicbillJRLD"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/electronicbillZXCL",
    name: "electronicbillZXCL",
    title: "在线车辆",
    component: () => import("@/pages/electronicbill/electronicbillZXCL"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/electronicbillSSLD",
    name: "electronicbillSSLD",
    title: "实时联单",
    component: () => import("@/pages/electronicbill/electronicbillSSLD"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/electronicbillYCLD",
    name: "electronicbillYCLD",
    title: "异常联单",
    component: () => import("@/pages/electronicbill/electronicbillYCLD"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/electronicbilldetailed",
    name: "electronicbilldetailed",
    title: "电子联单详情",
    component: () => import("@/pages/electronicbill/electronicbilldetailed"),
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "/electronicbillmap",
    name: "electronicbillmap",
    title: "车辆轨迹图",
    component: () => import("@/pages/electronicbill/electronicbillmap"),
    meta: {
      requireAuth: true,
    },
  },

  // +----------------------------------------------------------------------
  // | Desc:单位
  // +----------------------------------------------------------------------
  {
    path: "/orgyunshu",
    name: "orgyunshu",
    title: "运输单位列表",
    component: () => import("@/pages/orgyunshu/list"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/orgjieshou",
    name: "orgjieshou",
    title: "接收单位列表",
    component: () => import("@/pages/orgjieshou/list"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/orgpaifang",
    name: "orgpaifang",
    title: "排放单位列表",
    component: () => import("@/pages/orgpaifang/list"),
    meta: {
      requireAuth: true,
    },
  },
  
  {
    path: "/orguserlist",
    name: "orguserlist",
    title: "排放单位列表",
    component: () => import("@/pages/user/list"),
    meta: {
      requireAuth: true,
    },
  },
  
  {
    path: "/orgduifanglist",
    name: "orgduifanglist",
    title: "堆放单位列表",
    component: () => import("@/pages/orgduifang/list"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/orgzycz",
    name: "orgzycz",
    title: "资源处置单位列表",
    component: () => import("@/pages/orgzycz/list"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/orgfj",
    name: "orgfj",
    title: "分拣中心",
    component: () => import("@/pages/orgzycz/fjlist"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/orgjmyh",
    name: "orgjmyh",
    title: "居民用户",
   
    component: () => import("@/pages/orguser/grlist"),
    meta: {
      requireAuth: true,
    },
  },

  {
    path: "/orgshhz",
    name: "orgshhz",
    title: "合作商体",
    component: () => import("@/pages/orguser/shlist"),
    meta: {
      requireAuth: true,
    },
  },

  // +----------------------------------------------------------------------
  // | Desc:载具
  // +----------------------------------------------------------------------
  {
    path: "/car",
    name: "car",
    title: "运输车辆列表",
    component: () => import("@/pages/car/car"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/box",
    name: "box",
    title: "车厢列表",
    component: () => import("@/pages/box/box"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/ship",
    name: "ship",
    title: "运输船舶列表",
    component: () => import("@/pages/ship/ship"),
    meta: {
      requireAuth: true,
    },
  },

  // +----------------------------------------------------------------------
  // | Desc:地图
  // +----------------------------------------------------------------------
  {
    path: "/map",
    name: "map",
    title: "排收分布图",
    component: () => import("@/pages/map/map/map"),
    meta: {
      requireAuth: true,
    },
  },

  {
    path: "/mapReli",
    name: "mapReli",
    title: "清运热力图",
    component: () => import("@/pages/map/mapReli/map"),
    meta: {
      requireAuth: true,
    },
  },

  {
    path: "/mapXianlu",
    name: "mapXianlu",
    title: "清运线路",
    component: () => import("@/pages/map/mapXianlu/map"),
    meta: {
      requireAuth: true,
    },
  },

  // +----------------------------------------------------------------------
  // | Desc:系统基础模块
  // +----------------------------------------------------------------------
  {
    path: "/login",
    name: "login",
    title: "登录页",
    component: () => import("@/pages/login/index"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/",
    name: "/",
    title: "默认访问",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "index",
    title: "首页",
    component: () => import("@/pages/index/index"),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "*",
    name: "404页",
    title: "404",
    component: () => import("@/layout/pages/404/404"),
  },
  {
    path: "/error",
    name: "error",
    title: "访问受限页",
    component: () => import("@/layout/pages/error/error"),
    meta: {
      requireAuth: true,
    },
  },
];
export const routers = [...allRouters];
